import { createApp } from 'vue';

import NcrModal from './NcrModal.vue';

let mounted = false;

export function initNcrModal(): void {
  const root = document.getElementById('ncrModalRoot');
  if (!root || mounted) return;

  createApp(NcrModal).mount(root);
  mounted = true;
}
